export default {
  'app.true': 'SÍ',
  'app.false': 'NO',
  'app.403.page': 'Sin permiso',
  'app.403.page.tip': 'Póngase en contacto con el administrador para obtener su permiso',
};
